<template>
  <div>
    <div class="content">
      <div class="all">
        <div class="SearchBar">
          <el-form
              ref="search"
              :inline="true"
              size="small"
          >
            <el-form-item label="通知小组:" class="searchItem" >
              <!--  @change="search" -->
              <el-select v-model="pageParams.groupId" clearable placeholder="请选择" style="width: 200px">
                <el-option
                    v-for="item in DataList"
                    :key="item.id"
                    :label="item.groupName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间段:" class="searchItem" style="margin-left: 10px">
              <el-date-picker
                  size="mini"
                  style="width: 300px;"
                  v-model="time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  @change="chooseTime"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="记录人:" class="searchItem" style="margin-left: 10px">
              <el-input v-model="pageParams.recordName" size="mini" placeholder="请输入关键字" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="关键字:" class="searchItem" style="margin-left: 10px">
              <el-input v-model="pageParams.keys" size="mini" placeholder="请输入报警人/地址/事故等级" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="" class="searchItem" style="margin-left: 10px">
              <el-button type="primary" @click="search" size="mini" >查询</el-button>
              <el-button type="warning" @click="restSearch" size="mini" >重置</el-button>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="addMore" size="mini" v-if="$anthButtons.getButtonAuth('bjjltj')">添加</el-button>
          <el-table
              ref="tableData"
              :data="tableData"
              style="margin-top: 10px"
              border
              :header-cell-style="{
							color: '#333',
							fontFamily: 'MicrosoftYaHeiUI',
							fontSize: '14px',
							fontWeight: 900,
							textAlign: 'left',
							background: '#f8f8f9',
						}"
              height="calc(100vh - 330px)"
              :stripe="true"
          >
            <el-table-column
                type="index"
                label="序号"
                width="50"
            >
            </el-table-column>
            <el-table-column
                prop="callName"
                label="报警人"
            >
            </el-table-column>
            <el-table-column
                prop="callPhone"
                label="报警人电话"
            >
            </el-table-column>
            <el-table-column
                prop="address"
                label="地址"
            >
            </el-table-column>
            <el-table-column
                prop="accidentLevel"
                label="事故等级"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="casualties"
                label="人员伤亡"
            >
              <template slot-scope="{row}">
                <span v-if="row.casualties==0">否</span>
                <span v-if="row.casualties==1">是</span>
                <span v-if="row.casualties==2">未知</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="groupName"
                label="通知小组"
            >
            </el-table-column>
            <el-table-column
                prop="recordName"
                label="记录人"
            >
            </el-table-column>
            <el-table-column
                prop="recordTime"
                label="记录时间"
                width="150"
            >
            </el-table-column>
            <el-table-column
                prop="recordStatus"
                label="状态"
            >
              <template slot-scope="{row}">
                {{row.recordStatus==1?'警报中':'解除报警'}}
              </template>
            </el-table-column>
            <el-table-column
                prop="outbound"
                label="外呼结果"
            >
            </el-table-column>
            <el-table-column
                prop="confirmName"
                label="确认接收名单"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="操作"
                width="200"
            >
              <template slot-scope="{row}">
                <el-button type="primary" size="mini" style="margin-right: 10px" @click="modify(row)" v-if="$anthButtons.getButtonAuth('bjjlbj')">编辑</el-button>
                <el-button v-if="row.recordStatus==1&&$anthButtons.getButtonAuth('bjjljcjb')" type="danger" size="mini" style="margin-right: 10px" @click="handle(row)" >解除警报</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="total">
            <el-pagination
                background
                layout="total, prev, pager, next,sizes, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageParams.current"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pageParams.size"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="uodataStatus?'新增报警':'编辑报警'"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        @close="closeDialog('pgform')"
    >
      <el-form ref="pgform" :model="pgform" label-width="80px" :rules="rules">
        <el-form-item label="报警人" prop="callName">
          <el-input type="text" placeholder="请输入" v-model="pgform.callName" name="limitLength" show-word-limit :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="报警电话" prop="callPhone">
          <el-input type="text" placeholder="请输入" v-model="pgform.callPhone" ></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input type="text" placeholder="请输入" v-model="pgform.address" name="limitLength" show-word-limit  maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="事故等级" prop="accidentLevel">
          <el-input type="textarea" placeholder="请输入" v-model="pgform.accidentLevel"  show-word-limit  maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="人员伤亡" prop="casualties">
          <el-radio v-model="pgform.casualties" label="1">是</el-radio>
          <el-radio v-model="pgform.casualties" label="0">否</el-radio>
          <el-radio v-model="pgform.casualties" label="2">未知</el-radio>
        </el-form-item>
        <el-form-item label="通知小组" prop="groupId" v-if="uodataStatus">
          <el-select v-model="pgform.groupId" clearable placeholder="请选择" style="width: 100%" filterable>
            <el-option
                v-for="item in DataList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="uodataStatus" type="primary" @click="submit('pgform')">确 定</el-button>
        <el-button v-else type="primary" @click="modifysubmit('pgform')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {addRecord, groupList, queryByPage, relieveRecord, updateRecord} from "../../RequestPort/kfOrder";

export default {
  name: "statistics",
  data(){
    return{
      uodataStatus:true,
      dialogVisible:false,
      pageParams:{
        materialName:'',
        size:10,
        current:1
      },
      number:30,
      total:null,
      time:[],
      tableData:[],
      pgform:{
        callName:'',
        callPhone:'',
        address:'',
        accidentLevel:'',
        casualties:'2',
        groupId:'',
      },
      DataList:[],
      rules:{
        callName:[{ required: true, message: "请输入", trigger: "change" }],
        callPhone:[{ required: true, message: "请输入", trigger: "change" },],
          // {required: true, message: "请输入正确的电话格式", pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, trigger: "change",}
        address:[{ required: true, message: "请输入", trigger: "change" }],
        accidentLevel:[{ required: true, message: "请输入", trigger: "change" }],
        groupId:[{ required: true, message: "请输入", trigger: "change" }],
        casualties: [{ required: true, message: "请输入", trigger: "change" }]
      }
    }
  },
  mounted() {
    groupList().then(res=>{
      this.DataList = res.data
    })
    this.loadList(this.pageParams);
  },
  methods:{
    closeDialog(formName){
      this.pgform = {
        callName:'',
        callPhone:'',
        address:'',
        accidentLevel:'',
        casualties:'2',
        groupId:'',
      },
      this.$refs[formName].resetFields(); // 重置表单移除校验
    },
    chooseTime(){
      if(this.time){
        this.pageParams.startTime = this.time[0]
        this.pageParams.endTime = this.time[1]
        this.loadList(this.pageParams)
      }
    },
    handle(row){
      this.$confirm('是否解除警报？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        type: 'warning'
      }).then(() => {
        relieveRecord({id:row.id}).then(res=>{
          if(res.code===200){
            this.$message.success(res.data)
            this.dialogVisible = false
            this.loadList(this.pageParams);
          }else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    submit(pgform){
      this.$refs[pgform].validate((valid) => {
        if(!valid) return
        addRecord(this.pgform).then(res=>{
          if(res.code===200){
            this.$message.success(res.data)
            this.dialogVisible = false
            this.loadList(this.pageParams);
          }else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    modifysubmit(pgform){
      this.$refs[pgform].validate((valid) => {
        if(!valid) return
        updateRecord(this.pgform).then(res=>{
          if(res.code===200){
            this.$message.success(res.data)
            this.dialogVisible = false
            this.loadList(this.pageParams);
          }else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    modify(row){
      this.uodataStatus = false
      let obj = JSON.parse(JSON.stringify(row))
      this.pgform = obj
      this.pgform.casualties = obj.casualties+''
      this.dialogVisible = true
    },
    search() {
      this.pageParams.current = 1;
      this.loadList(this.pageParams);
    },
    restSearch() {
      this.pageParams = {
        keys:'',
        groupId:'',
        recordName:'',
        current: 1,
        size: 10
      };
      this.time=[]
      this.loadList(this.pageParams);
    },
    addMore(){
      this.uodataStatus = true
      this.dialogVisible = true
    },
    loadList(obj){
      queryByPage(obj).then(res=>{
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    handleCurrentChange(current) {
      this.pageParams.current = current;
      this.loadList(this.pageParams);
    },
    handleSizeChange(val) {
      this.pageParams.size = val;
      this.handleCurrentChange(1);
    },
  }
}
</script>

<style lang="scss" scoped>
.searchBox {
  .searchBoxForm {
    display: flex;
    align-items: center;
  }
}
.tableTool{
  height: 25px;
}
.label {
  color: #909399;
}
.content-item {
  color: #444444;
}
.SearchBar {
  border-radius: 5px;
  margin: 10px;
  padding-top: 10px;
  padding-left: 20px;
  background-color: #ffffff;
}
.all {
  background-color:#f3f4f8;height:auto
}
.content {
  background: #f3f4f8;
  width: 100%;
  border-radius: 6px;
  overflow:auto;
  height: calc(100vh - 120px);
}
.search{
  width: 190px;
}
.total{
  margin-left: 15px;
  margin-top: 10px;
}
.table{
  overflow:auto;
  height: 520px;
}
</style>